import React from 'react';
import {SkeletonProfileImage} from 'sections/services-marketplace/experts/components';
import {
  TextContainer,
  SkeletonDisplayText,
  SkeletonBodyText,
} from '@shopify/polaris';

import styles from './ExpertDetails.scss';

export function SkeletonExpertDetails() {
  return (
    <div className={styles.ExpertDetails}>
      <div className={styles.FlexContainer}>
        <SkeletonProfileImage size="Large" />
        <div className={styles.Info}>
          <TextContainer spacing="tight">
            <div className={styles.BusinessName}>
              <SkeletonDisplayText size="extraLarge" />
            </div>
            <div className={styles.InfoFlexContainer}>
              <div className={styles.Location}>
                <div style={{width: 200}}>
                  <SkeletonBodyText lines={2} />
                </div>
              </div>
            </div>
          </TextContainer>
        </div>
      </div>
      <div className={styles.Bio}>
        <TextContainer>
          <SkeletonBodyText />
        </TextContainer>
      </div>
    </div>
  );
}
